import type { Filter } from '@/types';

export interface FocusViewParams {
	title?: string;
	subtitle?: string;
	filters?: Filter[];
	columns?: string[];
	selectedUserId?: number;
	discussionUserId?: number;
	sortBy?: string;
	sortOrder?: 'asc' | 'desc';
	logicalOperator?: 'and' | 'or';
	/** Optional navigation function (e.g., router.push). If provided, uses Next.js navigation for proper back/forward support. */
	navigate?: (url: string) => void;
}

export function encodeFocusViewUrl(params: FocusViewParams): string {
	const searchParams = new URLSearchParams();

	if (params.title) {
		searchParams.set('title', params.title);
	}
	if (params.subtitle) {
		searchParams.set('subtitle', params.subtitle);
	}
	if (params.filters?.length) {
		searchParams.set('filters', btoa(JSON.stringify(params.filters)));
	}
	if (params.columns?.length) {
		searchParams.set('columns', params.columns.join('|'));
	}
	if (params.sortBy) {
		searchParams.set('orderBy', params.sortBy);
	}
	if (params.sortOrder) {
		searchParams.set('order', params.sortOrder);
	}
	if (params.selectedUserId) {
		searchParams.set('selectedUserId', params.selectedUserId.toString());
	}
	if (params.discussionUserId) {
		searchParams.set('discussionUserId', params.discussionUserId.toString());
	}
	if (params.logicalOperator) {
		searchParams.set('logicalOperator', params.logicalOperator);
	}

	return `/users/search?${searchParams.toString()}`;
}

export function decodeFocusViewFilters(filtersParam: string): Filter[] {
	try {
		return JSON.parse(atob(filtersParam));
	} catch {
		return [];
	}
}
